import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';
import {WinPresentationView} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationView';
import {WinPresentationModule} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationModule';

export class WinPresentationFreeSpinsPaysState extends ModuleState<WinPresentationView, WinPresentationModule> {

    public onEnterState(): void {
        if (this.module.isBigWin()) {
            this.view.playPaysAnimationOneCycle();
        } else {
            this.view.playPayAnimation();
        }
    }

    public onLeaveState(): void {
        this.module.stop();
        this.module.stopMeter(true);
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(BigWinEvents.STARTED, this.onBigWinStarted.bind(this));
    }

    protected onReelsSpinningStarted(): void {
        this.module.gotoState(WinPresentationModule.FREESPINS_BASIC_STATE);
    }

    protected onBigWinStarted(): void {
        this.module.stop();
    }
}
